import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { EventsService } from "../../_services/events.service";
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-eventslist',
  templateUrl: './eventslist.component.html',
  styleUrls: ['./eventslist.component.css']
})
export class EventslistComponent implements OnInit {

  eventsList: [];
  userdetaild: string;
  returnUrl: string;
  baseUrl: string = environment.baseUrl;
  imgKey: string = environment.imgKey;
  encodedKey: string;


  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private eventsservice: EventsService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getEvents();
  }

  duplicateForm(eventID) {
    const payload = {
      id: eventID
    };

    this.getEventById(payload);
  }

  getEventById(payload) {
    this.eventsservice.getEventById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            sessionStorage.setItem("eventData",JSON.stringify(data.EventsDetail))
            this.router.navigate(['/add-event']);
          }
        }
      )
  }

  getEvents() {
    this.eventsservice.getEvents()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.eventsList = data.EventsList;

            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);

          } else {
            this.toaster.showError('eventsList', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('eventsList', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deleteEvent(id) {
    const payload = {id: id};
    this.eventsservice.deleteEventById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.getEvents();
            this.toaster.showSuccess('eventsList', data.ResponseMessage);
          } else {
            this.toaster.showError('eventsList', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('eventsList', error.error.ResponseMessage);
        });
  }

}
